export const generateInitialsImage = (name) => {
  const initials = name
    .split(" ")
    .map(n => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();

  const bgColor = stringToColor(name)

  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50">
      <rect width="100%" height="100%" fill="${bgColor}" rx="25" />
      <text
        x="50%"
        y="50%"
        text-anchor="middle"
        dominant-baseline="central"
        font-size="23"
        fill="#fff"
        font-family="Segoe UI, Arial, sans-serif"
        font-weight="600"
      >
        ${initials}
      </text>
    </svg>
  `;

  return `data:image/svg+xml;base64,${btoa(svg)}`;
}

function stringToColor(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors = [
    "#5B6DEF", "#E81123", "#FF8C00",
    "#107C10", "#0078D4", "#8764B8"
  ];

  return colors[Math.abs(hash) % colors.length];
}